import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/userGroups/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_DESCRIPTION = NAMESPACE + 'SET_DESCRIPTION'

export const REFRESH_USERS = NAMESPACE + 'REFRESH_USERS'
export const SET_USERS_LOAD_STATUS = NAMESPACE + 'SET_USERS_LOAD_STATUS'
export const SET_USERS_CURSOR = NAMESPACE + 'SET_USERS_CURSOR'
export const ADD_USER = NAMESPACE + 'ADD_USER'
export const ADD_USERS = NAMESPACE + 'ADD_USERS'
export const REMOVE_USER = NAMESPACE + 'REMOVE_USER'

export const SET_OWNERS_LOAD_STATUS = NAMESPACE + 'SET_OWNERS_LOAD_STATUS'
export const SET_USER_OWNERS = NAMESPACE + 'SET_USER_OWNERS'
export const ADD_USER_OWNER = NAMESPACE + 'ADD_USER_OWNER'
export const REMOVE_USER_OWNER = NAMESPACE + 'REMOVE_USER_OWNER'
export const SET_GROUP_OWNERS = NAMESPACE + 'SET_GROUP_OWNERS'
export const ADD_GROUP_OWNER = NAMESPACE + 'ADD_GROUP_OWNER'
export const REMOVE_GROUP_OWNER = NAMESPACE + 'REMOVE_GROUP_OWNER'

export const REFRESH_BOARDS = NAMESPACE + 'REFRESH_BOARDS'
export const SET_BOARDS_LOAD_STATUS = NAMESPACE + 'SET_BOARDS_LOAD_STATUS'
export const ADD_BOARDS = NAMESPACE + 'ADD_BOARDS'

export const REFRESH_SYNC_TARGETS = NAMESPACE + 'REFRESH_SYNC_TARGETS'
export const SET_SYNC_TARGETS_LOAD_STATUS = NAMESPACE + 'SET_SYNC_TARGETS_LOAD_STATUS'
export const ADD_SYNC_TARGETS = NAMESPACE + 'ADD_SYNC_TARGETS'
export const REMOVE_SYNC_TARGET = NAMESPACE + 'REMOVE_SYNC_TARGET'

export const REFRESH_TASKS = NAMESPACE + 'REFRESH_TASKS'
export const SET_TASKS_LOAD_STATUS = NAMESPACE + 'SET_TASKS_LOAD_STATUS'
export const ADD_TASKS = NAMESPACE + 'ADD_TASKS'
export const REMOVE_TASK = NAMESPACE + 'REMOVE_TASK'

const initialState = { }

const userGroupDefaults = {
  name: '',
  description: '',

  internal: false,
  external: false,

  users: [],
  usersLoading: false,
  usersLoaded: false,
  usersCursor: null,

  userOwners: [],
  groupOwners: [],
  ownersLoading: false,
  ownersLoaded: false,

  boards: [],
  boardsById: {},
  boardsLoading: false,
  boardsLoaded: false,

  syncTargets: [],
  syncTargetsById: {},
  syncTargetsLoading: false,
  syncTargetsLoaded: false,

  tasks: [],
  tasksById: {},
  tasksLoading: false,
  tasksLoaded: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        [action.payload.id]: {
          ...userGroupDefaults,
          ...state[action.payload.id],
          ...action.payload
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state
      }
      action.payload.forEach(element => {
        newState[element.id] = {
          ...userGroupDefaults,
          ...newState[element.id],
          ...element
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state
      }
      delete newState[action.payload.id]
      return newState
    }
    case SET_NAME:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          name: action.payload.name
        }
      } : state
    case SET_DESCRIPTION:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          description: action.payload.description
        }
      } : state
    case REFRESH_USERS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          users: [],
          usersLoading: false,
          usersLoaded: false,
          usersCursor: null
        }
      } : state
    case SET_USERS_LOAD_STATUS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          usersLoading: action.payload.loading,
          usersLoaded: action.payload.loaded
        }
      } : state
    case SET_USERS_CURSOR:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          usersCursor: action.payload.cursor
        }
      } : state
    case ADD_USER:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          users: addUniqueValueToArray({
            array: state[action.payload.id].users,
            value: action.payload.userId,
            index: action.payload.index
          })
        }
      }
    case ADD_USERS: {
      const newState = {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id]
        }
      }
      action.payload.userIds.forEach(id => {
        newState[action.payload.id].users = addUniqueValueToArray({
          array: newState[action.payload.id].users,
          value: id
        })
      })
      return newState
    }
    case REMOVE_USER:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          users: [
            ...state[action.payload.id].users.filter(userId => userId !== action.payload.userId)
          ]
        }
      }
    case SET_OWNERS_LOAD_STATUS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          ownersLoading: action.payload.loading,
          ownersLoaded: action.payload.loaded
        }
      } : state
    case SET_USER_OWNERS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          userOwners: action.payload.userIds
        }
      } : state
    case ADD_USER_OWNER:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          userOwners: [
            action.payload.userId,
            ...state[action.payload.id].userOwners.filter(userId => userId !== action.payload.userId)
          ]
        }
      } : state
    case REMOVE_USER_OWNER:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          userOwners: state[action.payload.id].userOwners.filter(userId => userId !== action.payload.userId)
        }
      } : state
    case SET_GROUP_OWNERS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          groupOwners: action.payload.groupIds
        }
      } : state
    case ADD_GROUP_OWNER:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          groupOwners: [
            action.payload.groupId,
            ...state[action.payload.id].groupOwners.filter(groupId => groupId !== action.payload.groupId)
          ]
        }
      } : state
    case REMOVE_GROUP_OWNER:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          groupOwners: state[action.payload.id].groupOwners.filter(groupId => groupId !== action.payload.groupId)
        }
      } : state
    case REFRESH_BOARDS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          boards: [],
          boardsById: {},
          boardsLoading: false,
          boardsLoaded: false
        }
      } : state
    case SET_BOARDS_LOAD_STATUS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          boardsLoading: action.payload.loading,
          boardsLoaded: action.payload.loaded
        }
      } : state
    case ADD_BOARDS: {
      const newState = {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          boardsById: { ...state[action.payload.id].boardsById }
        }
      }
      action.payload.boards.forEach(board => {
        newState[action.payload.id].boards = addUniqueValueToArray({
          array: newState[action.payload.id].boards,
          value: board.id
        })
        newState[action.payload.id].boardsById[board.id] = {
          ...board
        }
      })
      return newState
    }
    case REFRESH_SYNC_TARGETS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          syncTargets: [],
          syncTargetsById: {},
          syncTargetsLoading: false,
          syncTargetsLoaded: false
        }
      } : state
    case SET_SYNC_TARGETS_LOAD_STATUS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          syncTargetsLoading: action.payload.loading,
          syncTargetsLoaded: action.payload.loaded
        }
      } : state
    case ADD_SYNC_TARGETS: {
      const newState = {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          syncTargetsById: { ...state[action.payload.id].syncTargetsById }
        }
      }
      action.payload.syncTargets.forEach(board => {
        newState[action.payload.id].syncTargets = addUniqueValueToArray({
          array: newState[action.payload.id].syncTargets,
          value: board.id
        })
        newState[action.payload.id].syncTargetsById[board.id] = {
          ...board
        }
      })
      return newState
    }
    case REMOVE_SYNC_TARGET: {
      const newState = {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          syncTargets: [
            ...state[action.payload.id].syncTargets.filter(id => id !== action.payload.syncTargetId)
          ],
          syncTargetsById: { ...state[action.payload.id].syncTargetsById }
        }
      }
      delete newState[action.payload.id].syncTargetsById[action.payload.syncTargetId]
      return newState
    }
    case REFRESH_TASKS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          tasks: [],
          tasksById: {},
          tasksLoading: false,
          tasksLoaded: false
        }
      } : state
    case SET_TASKS_LOAD_STATUS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          tasksLoading: action.payload.loading,
          tasksLoaded: action.payload.loaded
        }
      } : state
    case ADD_TASKS: {
      const newState = {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          tasksById: { ...state[action.payload.id].tasksById }
        }
      }
      action.payload.tasks.forEach(board => {
        newState[action.payload.id].tasks = addUniqueValueToArray({
          array: newState[action.payload.id].tasks,
          value: board.id
        })
        newState[action.payload.id].tasksById[board.id] = {
          ...board
        }
      })
      return newState
    }
    case REMOVE_TASK: {
      const newState = {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          tasks: [
            ...state[action.payload.id].tasks.filter(id => id !== action.payload.syncTargetId)
          ],
          tasksById: { ...state[action.payload.id].tasksById }
        }
      }
      delete newState[action.payload.id].tasksById[action.payload.syncTargetId]
      return newState
    }
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (userGroupsArray) {
  return {
    type: ADD_ARRAY,
    payload: userGroupsArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setName ({ id, name }) {
  return {
    type: SET_NAME,
    payload: {
      id,
      name
    }
  }
}

export function setDescription ({ id, description }) {
  return {
    type: SET_DESCRIPTION,
    payload: {
      id,
      description
    }
  }
}

export function refreshUsers ({ id }) {
  return {
    type: REFRESH_USERS,
    payload: {
      id
    }
  }
}

export function setUsersLoadStatus ({ id, loading, loaded }) {
  return {
    type: SET_USERS_LOAD_STATUS,
    payload: {
      id,
      loading,
      loaded
    }
  }
}

export function setUsersCursor ({ id, cursor }) {
  return {
    type: SET_USERS_CURSOR,
    payload: {
      id,
      cursor
    }
  }
}

export function addUser ({ id, userId, index }) {
  return {
    type: ADD_USER,
    payload: {
      id,
      userId,
      index
    }
  }
}

export function addUsers ({ id, userIds }) {
  return {
    type: ADD_USERS,
    payload: {
      id,
      userIds
    }
  }
}

export function removeUser ({ id, userId }) {
  return {
    type: REMOVE_USER,
    payload: {
      id,
      userId
    }
  }
}

export function setOwnersLoadStatus ({ id, loading, loaded }) {
  return {
    type: SET_OWNERS_LOAD_STATUS,
    payload: {
      id,
      loading,
      loaded
    }
  }
}

export function setUserOwners ({ id, userIds }) {
  return {
    type: SET_USER_OWNERS,
    payload: {
      id,
      userIds,
    }
  }
}

export function addUserOwner ({ id, userId }) {
  return {
    type: ADD_USER_OWNER,
    payload: {
      id,
      userId,
    }
  }
}

export function removeUserOwner ({ id, userId }) {
  return {
    type: REMOVE_USER_OWNER,
    payload: {
      id,
      userId,
    }
  }
}

export function setGroupOwners ({ id, groupIds }) {
  return {
    type: SET_GROUP_OWNERS,
    payload: {
      id,
      groupIds,
    }
  }
}

export function addGroupOwner ({ id, groupId }) {
  return {
    type: ADD_GROUP_OWNER,
    payload: {
      id,
      groupId,
    }
  }
}

export function removeGroupOwner ({ id, groupId }) {
  return {
    type: REMOVE_GROUP_OWNER,
    payload: {
      id,
      groupId,
    }
  }
}

export function refreshBoards ({ id }) {
  return {
    type: REFRESH_BOARDS,
    payload: {
      id
    }
  }
}

export function setBoardsLoadStatus ({ id, loading, loaded }) {
  return {
    type: SET_BOARDS_LOAD_STATUS,
    payload: {
      id,
      loading,
      loaded
    }
  }
}

export function addBoards ({ id, boards }) {
  return {
    type: ADD_BOARDS,
    payload: {
      id,
      boards
    }
  }
}

export function refreshSyncTargets ({ id }) {
  return {
    type: REFRESH_SYNC_TARGETS,
    payload: {
      id
    }
  }
}

export function setSyncTargetsLoadStatus ({ id, loading, loaded }) {
  return {
    type: SET_SYNC_TARGETS_LOAD_STATUS,
    payload: {
      id,
      loading,
      loaded
    }
  }
}

export function addSyncTargets ({ id, syncTargets }) {
  return {
    type: ADD_SYNC_TARGETS,
    payload: {
      id,
      syncTargets
    }
  }
}

export function removeSyncTarget ({ id, syncTargetId }) {
  return {
    type: REMOVE_SYNC_TARGET,
    payload: {
      id,
      syncTargetId
    }
  }
}

export function refreshTasks ({ id }) {
  return {
    type: REFRESH_TASKS,
    payload: {
      id
    }
  }
}

export function setTasksLoadStatus ({ id, loading, loaded }) {
  return {
    type: SET_TASKS_LOAD_STATUS,
    payload: {
      id,
      loading,
      loaded
    }
  }
}

export function addTasks ({ id, tasks }) {
  return {
    type: ADD_TASKS,
    payload: {
      id,
      tasks
    }
  }
}

export function removeTask ({ id, taskId }) {
  return {
    type: REMOVE_TASK,
    payload: {
      id,
      taskId
    }
  }
}
